import { useTranslation } from 'react-i18next';
import { cn } from '@shared/utils';
import { Text, TextColorsEnum } from '../text';

interface NoDataProps {
  className?: string;
  text?: string;
  color?: TextColorsEnum;
}

export const NoData = (props: NoDataProps) => {
  const { t } = useTranslation();

  const text = props.text ?? t('noData.default');
  return (
    <Text tag='p' className={cn('flex items-center justify-center p-6', props.className)} color={props.color || 'secondary'}>
      {text}
    </Text>
  );
};
